export default "__VITE_ASSET__IfUoHOtu__"